import { CLEAR_GIVEAWAYS } from 'root/src/client/logic/api/actionIds';
export const clearGiveaways = () => ({
    type: CLEAR_GIVEAWAYS,
});
